import { startTransition, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAtomValue } from 'jotai';
import T from '@wojtekmaj/react-t';

import Button from '@rewardopl/react-ui/button';

import { ButtonWrapper, ContentWrapper, PageWrapper, Title } from './index.styles';

import ScrollableSlides from './scrollable_slides';
import Slide from './slide';

import { scrollToChild } from '../../../utils/carousel';

import { configLoginLoadable } from '../../../store';

import onboarding1Avif2 from '../../../static/onboarding/onboarding-1@2x.avif';
import onboarding1Png2 from '../../../static/onboarding/onboarding-1@2x.png';
import onboarding1Webp2 from '../../../static/onboarding/onboarding-1@2x.webp';
import onboarding1Avif from '../../../static/onboarding/onboarding-1.avif';
import onboarding1Png from '../../../static/onboarding/onboarding-1.png';
import onboarding1Webp from '../../../static/onboarding/onboarding-1.webp';
import onboarding2 from '../../../static/onboarding/onboarding-2.svg';

const slides = [
  {
    id: 1,
    fetchPriority: 'high',
    image: onboarding1Png,
    image2: onboarding1Png2,
    imageWebp: onboarding1Webp,
    imageWebp2: onboarding1Webp2,
    imageAvif: onboarding1Avif,
    imageAvif2: onboarding1Avif2,
    text: 'Welcome aboard!',
    subText: 'Visit our cafés, collect Lajkoniks, and exchange them for rewards!',
  },
  {
    id: 2,
    image: onboarding2,
    text: 'We’re celebrating your birthday!',
    subText: 'On this special day, a little surprise awaits you!',
  },
] as const;

export default function OnboardingPage() {
  const navigate = useNavigate();
  const scrollContainer = useRef<HTMLDivElement>(null);
  const [currentChildIndex, onChildChange] = useState(0);
  useAtomValue(configLoginLoadable);

  function navigateToLogin() {
    startTransition(() => {
      navigate('/login');
    });
  }

  function scrollToNext() {
    if (!scrollContainer.current) {
      return;
    }

    scrollToChild(currentChildIndex + 1, scrollContainer.current);
  }

  return (
    <PageWrapper>
      <ContentWrapper>
        <Title>
          <T>Welcome aboard!</T>
        </Title>
        <ScrollableSlides onChildChange={onChildChange} scrollContainer={scrollContainer}>
          {slides.map((slide) => (
            <Slide key={slide.id} {...slide} />
          ))}
        </ScrollableSlides>
        <ButtonWrapper>
          {currentChildIndex === slides.length - 1 ? (
            <Button className="primary" key="next" onClick={navigateToLogin}>
              <T>Let’s begin</T>
            </Button>
          ) : (
            <>
              <Button key="skip" onClick={navigateToLogin}>
                <T>Login</T>
              </Button>
              <Button className="primary" key="next" onClick={scrollToNext} type="button">
                <T>Next</T>
              </Button>
            </>
          )}
        </ButtonWrapper>
      </ContentWrapper>
    </PageWrapper>
  );
}
